/*
  DCI TECH Guatemala - "Agregar a una lista" outside the cart (product page), 2026-10-03.
  Same storage as the cart's "Tus listas" (sections/dci-cart.liquid): localStorage 'dciLists' =
  { active, lists: [{ id, name, items: [{ vid, u, t, i, p, ven, q }] }] }, 'later' = Guardado para después.
  Amazon-style: one click on a list adds the product; with no lists yet "Mi lista de deseos" is created on
  that click; naming a list is optional ("+ Crear nueva lista"). No <form> elements: the button sits inside
  the product form, and a nested form would be dropped (Enter would add to cart).

  DCILists.menu(button, getItem)  - getItem() returns the item at click time (current variant, price)
*/
(function () {
  if (window.DCILists) return;
  var KEY = 'dciLists', WISH = 'Mi lista de deseos';
  function get() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function put(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  function state() {
    var s = get();
    if (!s || !Array.isArray(s.lists)) s = { active: 'later', lists: [] };
    if (!s.lists.some(function (l) { return l.id === 'later'; })) s.lists.unshift({ id: 'later', name: 'Guardado para después', items: [] });
    return s;
  }
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function add(listId, item, name) {
    var s = state();
    if (listId === '__new') { listId = 'l' + Date.now().toString(36); s.lists.push({ id: listId, name: name || WISH, items: [] }); }
    var l = s.lists.filter(function (x) { return x.id === listId; })[0];
    var ex = l.items.filter(function (x) { return x.vid === item.vid; })[0];
    if (ex) ex.q = Math.max(ex.q || 1, item.q || 1); else l.items.unshift(item);
    s.active = listId; put(s);
    return l.name;
  }
  function close() { document.querySelectorAll('.dci-lm').forEach(function (m) { var b = m.parentElement.querySelector('[aria-expanded="true"]'); if (b) b.setAttribute('aria-expanded', 'false'); m.remove(); }); }
  function done(btn, name) {
    var old = btn.dataset.label || btn.innerHTML; btn.dataset.label = old;
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l5 5L19 7"/></svg>Guardado en «' + esc(name) + '» · <a href="/cart#listas">Ver mis listas</a>';
    btn.classList.add('is-ok');
  }
  function menu(btn, getItem) {
    if (btn.getAttribute('aria-expanded') === 'true') { close(); return; }
    close();
    var item = getItem(), s = state(), mine = s.lists.filter(function (l) { return l.id !== 'later'; });
    var m = document.createElement('div');
    m.className = 'dci-lm'; m.setAttribute('role', 'menu');
    m.innerHTML = '<p class="dci-lm__t">Agregar a una lista</p>' + (mine.length ? mine.map(function (l) {
      var has = l.items.some(function (x) { return x.vid === item.vid; });
      return '<button type="button" role="menuitem" data-lm-to="' + esc(l.id) + '"><b>' + esc(l.name) + '</b><span>' + (has ? 'Ya está en esta lista' : l.items.length + (l.items.length === 1 ? ' producto' : ' productos')) + '</span></button>';
    }).join('') : '<button type="button" role="menuitem" data-lm-to="__wish"><b>' + WISH + '</b><span>Se crea al guardar este producto</span></button>') +
      '<button type="button" class="dci-lm__more" data-lm-more>+ Crear nueva lista</button>' +
      '<div class="dci-lm__new" data-lm-new hidden><input type="text" maxlength="40" placeholder="Ej. Cumpleaños de Ana" aria-label="Nombre de la nueva lista"><button type="button" data-lm-create>Crear</button></div>' +
      '<p class="dci-lm__foot">Tus listas se guardan en este dispositivo. Puedes verlas y compartirlas desde tu carrito.</p>';
    btn.parentElement.appendChild(m);
    btn.setAttribute('aria-expanded', 'true');
    m.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t) return;
      e.preventDefault(); e.stopPropagation();
      if (t.hasAttribute('data-lm-more')) { var nw = m.querySelector('[data-lm-new]'); nw.hidden = false; t.hidden = true; nw.querySelector('input').focus(); return; }
      if (t.hasAttribute('data-lm-create')) { create(); return; }
      if (t.dataset.lmTo) { var name = add(t.dataset.lmTo === '__wish' ? '__new' : t.dataset.lmTo, item, WISH); close(); done(btn, name); }
    });
    function create() {
      var inp = m.querySelector('[data-lm-new] input'), name = (inp.value || '').trim().slice(0, 40);
      if (!name) { inp.focus(); return; }
      var n = add('__new', item, name); close(); done(btn, n);
    }
    m.querySelector('[data-lm-new] input').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); create(); } });
    m.querySelector('button').focus();
  }
  document.addEventListener('click', function (e) { if (!e.target.closest('.dci-lm') && !e.target.closest('[data-dci-addlist-btn]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.DCILists = { menu: menu, state: state };
})();
